export default __webpack_public_path__ + "static/media/explore_and_purchase_image.541c0948.svg";